// built in
import React, {
    useCallback,
    useContext,
    useEffect,
    useState
} from 'react';
import PropTypes from 'prop-types'
//external
import {
    Modal,
    Radio,
    Space,
    Steps,
    Button,
    Checkbox
} from 'antd';
import { Fileuploader } from '@ap-evolved/evolved-ui.ui.fileuploader'
//internal
import FilterContext from './FilterContext'
import chart from '../../utils/chart'
import dashboardClient from '../../utils/dashboardClient'

const { Step } = Steps;

const ExportModal = ({
    showModal,
    setShowModal
}) => {
    const {
        exportOptions,
        clientName,
        componentState,
        setComponentState
    } = useContext(FilterContext)


    const [selected, setSelected] = useState(exportOptions[0]?.value)
    const [currentStep, setCurrentStep] = useState(0)
    const [isDefaultLayout, setIsDefaultLayout] = useState(true)
    const [uploadComplete, setUploadComplete] = useState(false)

    const reset = () => {
        setShowModal(false)
        setCurrentStep(0)
        setUploadComplete(false)
        setIsDefaultLayout(true)
    }


    const handleOk = useCallback(() => {
        setShowModal(false)
        setCurrentStep(0)
        const newState = {
            ...componentState,
            export: true,
            defaultLayout: isDefaultLayout,
            exportOption: selected

        }

        reset()

        setComponentState(newState)
    })


    const steps = [
        {
            stepKey: 0,
            title: "Export options",
            content: <>
                <p>
                    The dashboard will be exported as a PowerPoint presentation. How would
                    you like the PPT to be generated?
                </p>
                <Radio.Group
                    onChange={(e) => {
                        setSelected(
                            e.target.value
                            // exportOptions.find((option) => option.value == e.target.value)
                        );
                    }}
                    value={selected}
                    defaultValue={exportOptions[0]?.value}
                >
                    <Space direction="vertical">
                        {
                            exportOptions.map((option) =>
                                <Radio key={`${option.value}_idx`} value={option.value}>{`${option.text}`}</Radio>
                            )
                        }
                    </Space>
                </Radio.Group>
            </>,
            footer: [
                <Button
                    onClick={() => { setCurrentStep(currentStep + 1) }}
                    type="primary"
                    style={{
                        width: '20%'
                    }}
                    key="next"
                >
                    Next
                </Button>
            ]
        },
        {
            stepKey: 1,
            title: "Layout configuration",
            content: <>
                { !isDefaultLayout &&
                    <>
                        <p>
                            Upload the layout configuration for the presentation
                        </p>
                        <Fileuploader
                            uploadUrl={process.env.REACT_APP_FILE_API_GCP}
                            processApi={"/upload"}
                            maxFiles={1}
                            bucketName={process.env.REACT_APP_BUCKET_NAME}
                            fieldName='file'
                            acceptedFileTypes={['application/json']}
                            onProcessComplete={() => { setUploadComplete(true) }}
                            fileName={`${clientName}/${chart.getReportId()}/layout/${clientName}_config`}
                            renameFile={true}
                        />
                    </>
                }
                <Checkbox
                    onChange={(e) => { setIsDefaultLayout(e.target.checked) }}
                    checked={isDefaultLayout}
                >
                    Use the default layout configuration
                </Checkbox>
            </>,
            footer: [
                <Button
                    onClick={() => { setCurrentStep(currentStep - 1) }}
                    type="text"
                    key="previous"
                    style={{
                        width: '20%'
                    }}
                >
                    Previous
                </Button>
                ,
                <Button
                    onClick={handleOk}
                    disabled={!isDefaultLayout && !uploadComplete}
                    type="primary"
                    key="done"
                    style={{
                        width: '20%'
                    }}
                >
                    Export
                </Button>]
        }
    ]


    useEffect(() => {
        console.log(selected)
    }, [selected])

    useEffect(()=>{
        if (showModal) console.log(process.env.REACT_APP_BUCKET_NAME, chart.getReportId())
    }, [showModal])


    return (
        <>
            <Modal
                title={`Export dashboard for ${dashboardClient.getClientObject(clientName)?.label}`}
                visible={showModal}
                onOk={handleOk}
                onCancel={reset}
                footer={steps[currentStep].footer}
                destroyOnClose
            >
                <Space
                    direction='vertical'
                    size='large'
                    style={{ width: '100%' }}
                >
                    <Steps current={currentStep}>
                        {steps.map(item => (
                            <Step key={item.stepKey} title={item.title} />
                        ))}
                    </Steps>
                    {steps[currentStep].content}
                </Space>
            </Modal>
        </>
    )
}

ExportModal.propTypes = {
    showModal: PropTypes.bool,
    setShowModal: PropTypes.func
}

ExportModal.defaultProps = {
    showModal: false,
    setShowModal: () => {
    }
}

export default ExportModal
